import { ChangeEvent, FC, useState } from 'react'
import { useForm } from 'react-hook-form'
import { appointmentService } from '../../../services'

import { Button, FormLabel, Title, Text, Textarea, Select, FormLabelError, FormMessageError, FormMessageSuccess } from '../../UI'
import { Modal, useModal } from '../../UI/Modal'

type MedicalAppointmentsDocumentsProps = {
  documents: any
  fromFamilyGroup: boolean
  familyFilter: any
  familyFilterSelected: any
  familyMemberId?: string
}
interface IDocumentForm {
  document: string,
  comment?: string,
  family_member_id?: string | null
}

const defaultValues: IDocumentForm = {
  document: '',
  comment: '',
  family_member_id: null
}

const MedicalAppointmentsDocuments:FC<MedicalAppointmentsDocumentsProps> = ({ documents, fromFamilyGroup = false, familyFilter, familyFilterSelected, familyMemberId = "" }) => {
  const { register, handleSubmit, formState: { errors } } = useForm<IDocumentForm>({
    defaultValues
  })
  const [submited, setSubmited] = useState<boolean>(false)
  const modal = useModal()
  const modalStatus = useModal()

  const [selectedFamilyMemberId, setSelectedFamilyMemberId] = useState<string>(familyMemberId)

  const onDocumentRequestModal = () => {
    modal.open()
  }

  const postForm = async (fData: IDocumentForm) => {
    const resp: any = await appointmentService.postDocument(fData)

    if(resp && resp.status === 'Ok') {
      modal.close()
      modalStatus.setStatus('SUCCESS')
    } else {
      modalStatus.setStatus('ERROR')
    }
    modalStatus.open()
    setSubmited(false)
  }

  const onSubmit = (fData: IDocumentForm) => {
    if (fromFamilyGroup) {
      fData.family_member_id = selectedFamilyMemberId;
    } else {
      fData.family_member_id = null;
    }
    setSubmited(true)
    postForm(fData)
  }

  const onFamilyMemberChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target
    setSelectedFamilyMemberId(value)
  }
  
  return (
    <>
      <div className="map-content-h d-flex flex-column align-items-center justify-content-center px-20">
        <Button style={{ width: 150 }} onClick={onDocumentRequestModal}>SOLICITAR</Button>
      </div>

      <Modal show={modal.show} maxWidth="415px" onClose={() => modal.close()}>
        <div className="py-50 px-25 lg:px-50">
          <Title weight="bold">Documentos</Title>

          <form noValidate autoComplete="off" className="mt-30" onSubmit={handleSubmit(onSubmit)}>
            <fieldset>
              <FormLabel>¿Qué documento necesitas?</FormLabel>
              <Select
                {...register('document', { required: 'Selecciona Documento' })}
                id="document"
                name="document"
                defaultValue=""
                fullWidth
                required
                loading={documents === ''}
                tabIndex={1}
                error={!!errors.document}
                className="mt-10"
              >
                <option value="" disabled>Selecciona el documento</option>
                {documents && documents.length > 0 && documents.map((it: any) =>
                  <option key={it.id} value={it.id}>{it.document_name}</option>
                )}
              </Select>
              {errors.document && <FormLabelError>{errors.document?.message}</FormLabelError>}
            </fieldset>

            {fromFamilyGroup &&
              <fieldset className="mt-30">
                <FormLabel>¿A quién le solicita el documento?</FormLabel>
                <Select
                  {...register('family_member_id')}
                  id="family_member_id"
                  name="family_member_id"
                  fullWidth
                  required
                  error={!!errors.family_member_id}
                  className="mt-10"
                  value={selectedFamilyMemberId || ''}
                  onChange={onFamilyMemberChange}
                >
                  <option value="" disabled>Selecciona el paciente</option>
                  {familyFilter.data.map((it: any) =>
                    <option key={it.id} value={it.id}>{it.name}</option>
                  )}
                </Select>
                {errors.family_member_id && <FormLabelError>{errors.family_member_id?.message}</FormLabelError>}
              </fieldset>
            }

            <fieldset className="mt-30">
              <FormLabel>Comentario <Text component="span" size="14" weight="default" inline>(Opcional)</Text></FormLabel>
              <Textarea
                {...register('comment')}
                id="comment"
                name="comment"
                placeholder="Ingresa un comentario"
                rows={5}
                fullWidth
                tabIndex={2}
                className="mt-10"
              />
            </fieldset>

            <fieldset className="mt-50">
              <Button
                type="submit"
                tabIndex={3}
                fullWidth
                disabled={submited}
              >SOLICITAR</Button>
            </fieldset>

          </form>
        </div>
      </Modal>

      <Modal show={modalStatus.show} maxWidth="345px" onClose={() => modalStatus.close()}>
        {modalStatus.status === 'SUCCESS' &&
          <FormMessageSuccess
            className="py-60 px-50"
            title="¡La solicitud ha sido recibida con éxito!"
            message="En un plazo de 48 horas te enviaremos el documento por correo electrónico"
          />
        }
        {modalStatus.status === 'ERROR' &&
          <FormMessageError
            className="py-60 px-50"
            message="No ha sido posible solicitud el documento"
            onClick={() => modalStatus.close()}
          />
        }
      </Modal>
    </>
  )
}

export { MedicalAppointmentsDocuments }